import script from "./InvestorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvestorCard.vue?vue&type=script&setup=true&lang=js"

import "./InvestorCard.css?vue&type=style&index=0&id=bb29a616&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb29a616"]])

export default __exports__